import { render, staticRenderFns } from "./PostsStats.vue?vue&type=template&id=c7435094&"
import script from "./PostsStats.vue?vue&type=script&lang=js&"
export * from "./PostsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports